import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove } from 'src/services/Receipts';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Select, { components } from 'react-select';
import { getDropdown } from 'src/services/Invoices';
import { getAll as getAllBanks } from 'src/services/Banks';
import Moment from 'moment';

function ReceiptActions() {
  let today = new Date();
  let todayMonth = today.getMonth() + 1;
  let todayYear = today.getFullYear();
  let todayDate = today.getDate();
  let showToday = todayYear + '-' + todayMonth + '-' + todayDate;
  const d = new Date();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var date = ('0' + d.getDate()).slice(-2);
  var datestringNow = d.getFullYear() + '-' + month + '-' + date;
  const [id, setID] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [receiptDate, setReceiptDate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [receiptNumber, setReceiptNumber] = useState('');
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [notes, setNotes] = useState('');

  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const [selectedBank, setSelectedBank] = useState({});
  const [bankOptions, setBankOptions] = useState([]);
  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      setIsEdit(true);
      setID(location.state.id);
      setReceiptDate(location?.state?.rawReceiptDate ?? '');
      setReceiptNumber(location?.state?.receiptNo ?? '');
      setPaymentAmount(location?.state?.rawPaymentAmount ?? 0);
      setRemaining(location?.state?.rawRemaining ?? 0);
      setNotes(location?.state?.notes ?? '');
      setSelectedBank({
        id: location.state.bankID,
        label: location.state.bankName,
        value: location.state.bankID
      });
      setSelectedInvoice({
        id: location.state.invoiceID,
        label: location.state.invoiceNo,
        value: location.state.invoiceID
      });
    } else {
      fetchBanks();
      fetchInvoices();
    }
  }, [location]);
  useEffect(() => {
    if (location.state) {
    } else {
      setRemaining((selectedInvoice?.remaining ?? 0) - paymentAmount);
    }
  }, [selectedInvoice, paymentAmount]);

  const fetchBanks = async () => {
    let response = await getAllBanks();

    if (response.success === 1) {
      let data =
        response?.banks.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id
          };
        }) ?? [];

      setBankOptions(data);
    }
  };
  const fetchInvoices = async () => {
    let response = await getDropdown();

    if (response.success === 1) {
      let data =
        response?.invoices.map((item) => {
          return {
            id: item.id,
            label: `${item.invoice_number} - ${item.customerName}`,
            remaining: item.remaining,
            value: item.id
          };
        }) ?? [];

      setInvoiceOptions(data);
    }
  };
  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor('red');
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        invoiceID: selectedInvoice.value,
        bankID: selectedBank.value,
        receiptDate: receiptDate,
        receiptNumber: receiptNumber,
        paymentAmount: paymentAmount,
        remaining: remaining,
        notes: notes
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor('red');
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get('errorMessage'));
            setOpen(true);
            setColor('red');
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CCardHeader>Actions - Receipt</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Invoice</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Cabang"
                value={selectedInvoice}
                options={invoiceOptions}
                onChange={(e) => {
                  setSelectedInvoice(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tanggal Pembayaran</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="date"
                value={receiptDate}
                max={Moment(showToday).format('YYYY-MM-DD')}
                onChange={(e) => setReceiptDate(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Pembayaran Saat Ini</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={paymentAmount}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setPaymentAmount(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Sisa</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={remaining}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setRemaining(e.target.value)}
                feedbackInvalid="Required value"
                required
                disabled
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Bank</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Bank"
                value={selectedBank}
                options={bankOptions}
                onChange={(e) => {
                  setSelectedBank(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Notes</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={notes}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setNotes(e.target.value)}
              />
            </CCol>
          </CRow>
        </div>
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          {isEdit ? (
            <div></div>
          ) : (
            <CButton
              color="success"
              style={{
                color: 'white'
              }}
              type="submit"
            >
              Save
            </CButton>
          )}
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default ReceiptActions;
